import { i18next } from '@frontend/i18n';
import { maskAccountNumber } from '@frontend/string';
import { currency } from '@frontend/design-system';
import type { CareCreditPatientData, CareCreditPatientStatus } from '../types/care-credit.types';

export type FormatCareCreditDataForDisplayOptions = {
  decimals?: number;
  showLastX?: number;
};

export const formatCareCreditDataForDisplay = (
  { amount, status, careCreditPersonId, accountNumber }: Partial<CareCreditPatientData> = {},
  { decimals = 0, showLastX = 4 }: FormatCareCreditDataForDisplayOptions = {}
) => {
  const statusMap: Record<CareCreditPatientStatus, string> = {
    CARDHOLDER: i18next.t('Active', { ns: 'payments-care-credit' }),
    PREAPPROVED: i18next.t('Pending', { ns: 'payments-care-credit' }),
    PREQUALIFICATION_NEEDED: i18next.t('Not Enrolled', { ns: 'payments-care-credit' }),
    UNKNOWN: i18next.t('Status unknown', { ns: 'payments-care-credit' }),
  };

  if (!amount || !status || !careCreditPersonId) {
    return {
      formattedAmount: '',
      formattedStatus: '',
      formattedCareCreditPersonId: '',
      formattedAccountNumber: '',
    };
  }

  return {
    formattedAmount: currency(amount, { decimals }),
    formattedStatus: statusMap[status],
    formattedAccountNumber: maskAccountNumber(accountNumber, {
      showLast: showLastX,
      minimumMaskLength: 4,
      maxMaskLength: 4,
    }),
    formattedCareCreditPersonId: maskAccountNumber(careCreditPersonId, {
      showLast: showLastX,
      normalizeDigits: false,
      maxMaskLength: 10,
    }),
  };
};
